
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'

// @ui-kit
import NewSelect from '@/ui-kit/NewSelect/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'
import RadioGroup from '@/common/components/UI/RadioGroup/index.vue'

// @types
import { CityT } from '@/core/types/cities.types'

// @new-services
import locationAPI from '@/new-services/location.service'

// composable
import useNotifications from '@/common/composable/useNotifications'
import useVuelidate from '@vuelidate/core'
import { requiredIf, required } from '@vuelidate/validators'

const INVOICE_TYPES = [
    { id: 1, name: 'LTL' },
    { id: 2, name: 'FTL' },
]

const YEARS = [
    { id: 2025, name: '2025' },
    { id: 2024, name: '2024' },
    { id: 2023, name: '2023' },
]

const MONTHS = [
    { id: 1, name: 'Январь' },
    { id: 2, name: 'Февраль' },
    { id: 3, name: 'Март' },
    { id: 4, name: 'Апрель' },
    { id: 5, name: 'Май' },
    { id: 6, name: 'Июнь' },
    { id: 7, name: 'Июль' },
    { id: 8, name: 'Август' },
    { id: 9, name: 'Сентябрь' },
    { id: 10, name: 'Октябрь' },
    { id: 11, name: 'Ноябрь' },
    { id: 12, name: 'Декабрь' },
]

export default defineComponent({
    components: {
        NewSelect,
        NewButton,
        RadioGroup,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isArchive: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            fromCityId: null as number | null,
            toCityId: null as number | null,
            transitCityIds: [] as Array<number | null>,
            invoiceType: null as number | null,
            //
            monthId: 1,
            year: null as number | null,
        })

        const isTransit = computed(() => Boolean(state.transitCityIds.length))

        const validation$ = useVuelidate(
            {
                fromCityId: { required: requiredIf(() => isTransit.value) },
                toCityId: { required: requiredIf(() => isTransit.value) },
                transitCityIds: {
                    $each: {
                        required,
                    },
                },
            },
            state
        )

        const data_state = reactive({
            cities: {
                is_loading: false,
                is_failed: false,
                list: [] as CityT[],
            },
        })

        const loadCities = async () => {
            try {
                data_state.cities.is_loading = true

                const response = await locationAPI.getCities()
                data_state.cities.list = response.data.data

                data_state.cities.is_failed = false
            } catch (error) {
                data_state.cities.is_failed = true
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении списка городов произошла ошибка',
                })
            } finally {
                data_state.cities.is_loading = false
            }
        }

        const onFiltersChanged = () => {
            if (props.disabled || props.loading) return

            validation$.value.$touch()
            if (isTransit.value && (!state.fromCityId || !state.toCityId)) {
                alert('Пожалуйста, выберите город "Откуда" и "Куда" или удалите Транзитный город!')
                return
            }
            if (!state.transitCityIds.every((cityId) => cityId)) {
                alert('Пожалуйста, выберите или удалите Транзитный город!')
                return
            }
            if (validation$.value.$invalid) {
                return
            }

            emit('submit', { ...state })
        }

        const onFiltersReset = () => {
            state.fromCityId = null
            state.toCityId = null
            state.transitCityIds = []
            state.invoiceType = null

            state.monthId = 1
            state.year = 2025

            emit('reset')
        }

        const addTransitCity = () => state.transitCityIds.push(null)

        const deleteTransitCity = (transit_city_index: number) => {
            state.transitCityIds.splice(transit_city_index, 1)
        }

        onBeforeMount(() => {
            loadCities()
            if (props.isArchive) {
                state.year = 2025
            }
        })

        return {
            validation$,
            state,
            data_state,
            //
            onFiltersChanged,
            onFiltersReset,
            addTransitCity,
            deleteTransitCity,
            //
            loadCities,
            INVOICE_TYPES,
            YEARS,
            MONTHS,
        }
    },
})
